"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTab = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TabMixin = require("../../mixins/components/TabMixin");
var _ToggleButton = require("../ToggleButton/ToggleButton");
var StyledTab = /*#__PURE__*/(0, _styledComponents.default)(_ToggleButton.ToggleButton).withConfig({
  displayName: "StyledTab",
  componentId: "c11n-8-107-0__sc-xahs5k-0"
})(["", ""], _TabMixin.TabMixin);
exports.StyledTab = StyledTab;